import { render, staticRenderFns } from "./search-reset-buttons.vue?vue&type=template&id=30b53273"
import script from "./search-reset-buttons.vue?vue&type=script&lang=js"
export * from "./search-reset-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports